import React, { useState } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import Link from 'next/link';
import { useTheme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import useConfig from 'hooks/useConfig';
import CookieSettingsModal from './CookieSettingsModal';
import { CookieProps } from 'types/config';
import AnimateButton from 'ui-component/extended/AnimateButton';

const CookieModal = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { onChangeCookiePolicy } = useConfig();

  const [settingsOpen, setSettingsOpen] = useState(false);
  const [cookieSettings, setCookieSettings] = useState<CookieProps>({
    necessary: true,
    performance: false,
    analytics: false,
    advertisement: false,
    others: false
  });

  const saveCookie = () => {
    onChangeCookiePolicy(cookieSettings);
  };

  return (
    <MainCard
      sx={{
        position: 'fixed',
        width: '100%',
        bottom: '0%',
        textAlign: 'start',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: '20vh',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[100],
        zIndex: 999,
        borderRadius: 0,
        padding: 2,
        pt: 0,
        '.MuiCardHeader-root': {
          padding: 2
        }
      }}
      title={formatMessage({ id: 'COOKIE.POLICY' })}
      content={false}
    >
      <Grid container padding={2.5} spacing={2}>
        <Grid size={{ xs: 12 }} lineHeight={1.4}>
          <Typography>{formatMessage({ id: 'COOKIE.TEXT.1' }, { newLine: <br /> })}</Typography>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography lineHeight={1.4} sx={{ a: { color: `${theme.palette.primary.main} !important` } }}>
            {formatMessage(
              { id: 'COOKIE.TEXT.2' },
              {
                newLine: <br />,
                privacyPolicy: <Link href="/privacy-policy">{formatMessage({ id: 'OUR.PRIVACY.POLICY' })}</Link>,
                cookiePolicy: <Link href="/cookie-policy">{formatMessage({ id: 'OUR.COOKIE.POLICY' })}</Link>
              }
            )}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button variant="outlined" onClick={() => setSettingsOpen(true)}>
            {formatMessage({ id: 'COOKIE.SETTINGS.BUTTON' })}
          </Button>
          <AnimateButton>
            <Button variant="contained" onClick={saveCookie} size="medium">
              {formatMessage({ id: 'COOKIE.SAVE.BUTTON' })}
            </Button>
          </AnimateButton>
        </Grid>
      </Grid>
      {settingsOpen && (
        <CookieSettingsModal
          open={settingsOpen}
          handleCloseModal={() => setSettingsOpen(false)}
          cookieSettings={cookieSettings}
          setCookieSettings={setCookieSettings}
        />
      )}
    </MainCard>
  );
};

export default CookieModal;
